import React from 'react';
import { ChatProvider, useChatContext } from './context/ChatContext';
import { HomePage } from './pages/HomePage';
import { ChatPage } from './pages/ChatPage';

// Simple view-based routing: context drives which page to show
const AppContent: React.FC = () => {
  const { state } = useChatContext();
  // If any message exists, we're in the chat. Otherwise show home.
  // LanguageSelector (via HomePage) dispatches SET_LANGUAGE which also clears messages.
  // We use a simple trick: the chat view is shown when state.view === 'chat'.
  // Since we added 'view' to state, this is clean. See context.
  return (state as any).view === 'chat' ? <ChatPage /> : <HomePage />;
};

const App: React.FC = () => (
  <ChatProvider>
    <AppContent />
  </ChatProvider>
);

export default App;
